import { gql } from "@apollo/client";

const USER_TOURNAMENTS = gql`
  query tournamentsByUserId(
    $userId: Int
    $league: Int
    $page: Int
    $limit: Int
    $title: String
    $approvalStatus: String
    $status: String
  ) {
    tournamentsByUserId(
      userId: $userId
      league: $league
      page: $page
      limit: $limit
      title: $title
      approvalStatus: $approvalStatus
      status: $status
    )
  }
`;

export default USER_TOURNAMENTS;
